import { ContactUserData } from '../../../types';
import { callExternalApi, CallResult } from '../../callExternalApi';

export const fetchContacts = async (accountIds: string[]) => {
  return await callExternalApi<ContactUserData[]>({
    url: `api/admin/portal_users/contacts?account_ids=${accountIds.join(',')}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export async function fetchSfUsersApi(): Promise<CallResult<ContactUserData[]>> {
  return await callExternalApi<ContactUserData[]>({
    url: 'api/admin/portal_users/sfusers',
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
}
